export default "__VITE_ASSET__BsZHJhX2__"